// @flow
import React, { Component } from "react";

import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";

import CompanyInfo from "../companies/CompanyInfo";

type BillingPaymentInfoPropsType = {
  company: { [key: string]: * }
};

class BillingPaymentInfo extends Component<BillingPaymentInfoPropsType, *> {
  constructor(props: BillingPaymentInfoPropsType) {
    super(props);
  }

  render(): React$Element<*> {
    return (
      <Paper className="box-wrapper">
        <Typography variant="h5" className="form-text">
          Billing Address
        </Typography>
        <CompanyInfo company={this.props.company} />
      </Paper>
    );
  }
}

export default BillingPaymentInfo;
